<div class="p-2">
    <div class="rana-page-header">
        <div>
            <h1 class="rana-page-title" style="font-size:20px;">Communication</h1>
            <p class="rana-page-subtitle" *ngIf="emails.length">{{ emails.length }} communication{{ emails.length === 1 ? '' : 's' }}</p>
        </div>
        <button type="button" class="btn btn-dark-primary" *ngIf="status != 'CLOSED'" (click)="cancelEdit()">
            <i class="uil uil-envelope-add"></i> New Communication
        </button>
    </div>

    <!-- Loader -->
    <div *ngIf="loading" class="text-center">
        <div class="spinner-border" role="status"></div>
    </div>

    <p *ngIf="emails.length === 0 && !loading" class="text-muted">No email communications yet.</p>

    <div class="rana-email-layout" *ngIf="emails.length > 0 && !loading">

        <!-- List -->
        <div class="rana-panel" style="padding:0;overflow:hidden;">
            <div class="rana-email-row"
                 *ngFor="let email of emails"
                 [class.selected]="selectedEmail?.messageId === email.messageId"
                 (click)="editEmail(email)">
                <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px;">
                    <div class="rana-email-row-subject">{{ email.subject }}</div>
                    <span class="rana-badge rana-badge-neutral" style="flex-shrink:0;">{{ email.fromEmail || 'events@rajputra.org' }}</span>
                </div>
                <div class="rana-email-row-meta">Updated {{ formatDate(email.updatedDate) || formatDate(email.createdDate) }}</div>
            </div>
        </div>

        <!-- Detail / compose -->
        <div class="rana-panel">
            <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:16px;">
                <h2 class="rana-panel-title" style="margin-bottom:0;">{{ isEditing ? 'Edit Communication' : 'New Communication' }}</h2>
                <div class="rana-email-actions" *ngIf="isEditing && status != 'CLOSED'">
                    <div class="rana-committee-icon-btn" title="Duplicate" (click)="duplicateEmail(selectedEmail!)">
                        <i class="uil uil-copy"></i>
                    </div>
                    <div class="rana-committee-icon-btn"
                         [class.disabled]="status !== 'OPEN'"
                         [title]="status === 'OPEN' ? 'Send email to all participants' : 'Event must be OPEN to send emails'"
                         (click)="status === 'OPEN' && sendEmail(selectedEmail!)">
                        <i class="uil uil-envelope-send"></i>
                    </div>
                    <div class="rana-committee-icon-btn" title="Send test email" (click)="enableTestMode(selectedEmail!)">
                        <i class="uil uil-flask"></i>
                    </div>
                    <div class="rana-committee-icon-btn" title="Delete" (click)="deleteEmail(selectedEmail!)">
                        <i class="uil uil-trash-alt"></i>
                    </div>
                </div>
            </div>

            <!-- Inline test-email composer -->
            <div class="rana-info-row" style="margin-bottom:16px;" *ngIf="testEmailRow?.messageId === selectedEmail?.messageId">
                <div class="rana-info-card" style="flex:none;width:100%;">
                    <div style="flex-grow:1;display:flex;align-items:center;gap:10px;">
                        <input type="email" class="form-control form-control-sm" placeholder="Enter test email"
                               [(ngModel)]="testEmail" name="testEmail" style="max-width:260px;">
                        <button *ngIf="!sending" type="button" class="rana-action-btn rana-action-btn-success" (click)="sendTestEmail(selectedEmail!)">Send Test</button>
                        <span *ngIf="sending" class="uil uil-spinner-alt spin-animation"></span>
                        <button *ngIf="!sending" type="button" class="rana-action-btn" (click)="cancelTestMode()">Cancel</button>
                    </div>
                </div>
            </div>

            <span *ngIf="status != 'CLOSED'; else readOnlyNotice">
                <form class="nfr-form-standard" (ngSubmit)="saveEmail()" #emailForm="ngForm">
                    <div class="mb-2">
                        <label>From</label>
                        <select class="form-control" [(ngModel)]="newEmail.fromEmail" name="fromEmail">
                            <option *ngFor="let opt of fromEmailOptions" [value]="opt">{{ opt }}</option>
                        </select>
                    </div>
                    <div class="mb-2">
                        <label>Subject</label>
                        <input type="text" class="form-control" [(ngModel)]="newEmail.subject" name="subject" required/>
                    </div>
                    <div class="mb-2">
                        <label>Body</label>
                        <app-rt-editor [(ngModel)]="newEmail.body" name="body" placeholder="Enter email content..."></app-rt-editor>
                    </div>
                    <div>
                        <button type="submit" class="btn btn-dark-primary m-2">
                            {{ isEditing ? 'Update' : 'Add' }} Communication
                        </button>
                        <button type="button" class="btn btn-secondary" (click)="cancelEdit()" *ngIf="isEditing">Cancel</button>
                    </div>
                </form>
            </span>
            <ng-template #readOnlyNotice>
                <p class="text-muted small">This event is closed — communications can no longer be added or edited.</p>
            </ng-template>
        </div>
    </div>
</div>
